if (typeof SwipperSlider !== 'function') {
  class SwipperSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSwiper = null;
    }

    connectedCallback() {
      this.paginationType = this.dataset.paginationType;
      this.swiperContainer = this.querySelector('.swiper');
      this.swiperNext = this.querySelector('.swiper-slider__next');
      this.swiperPrev = this.querySelector('.swiper-slider__prev');
      this.swiperPagination = this.querySelector('.swiper-slider__pagination');
      this.swiperScrollbar = this.querySelector('.swiper-slider__scrollbar');
      this.swiperSettings = JSON.parse(this.querySelector('[data-swiper-settings]')?.textContent || '{}');

      this.init = this.init.bind(this);
      this.initSwiperLogic = this.initSwiperLogic.bind(this);

      this.init();
      document.addEventListener('shopify:section:load', this.init);
      // window.addEventListener('resize', this.initSwiperLogic);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.init);
      // window.removeEventListener('resize', this.initSwiperLogic);

      if (this.currentSwiper?.destroy) {
        this.currentSwiper.destroy(true, true);
        this.currentSwiper = null;
      }
    }

    init() {
      this.initSwiperLogic();
    }

    initSwiperLogic() {
      if (!this.swiperContainer) return;
      if (this.currentSwiper && this.currentSwiper.destroy) {
        this.currentSwiper.destroy(true, true);
      }

      const options = {
        a11y: {
          enabled: true,
          ...this.swiperSettings["a11y"],
        },
        navigation: {
          prevEl: this.swiperPrev,
          nextEl: this.swiperNext,
        },
        pagination: {
          clickable: true,
          el: this.swiperPagination,
          type: this.paginationType == 'progressbar' ? 'progressbar' : 'bullets',
        },
        scrollbar: {
          draggable: true,
          el: this.swiperScrollbar,
          hide: false,
        },
        // Lets a section that owns the slider's surroundings follow the active
        // slide (for example a media frame that matches the active card).
        // `index` is the position in the original order, loop clones excluded.
        on: {
          realIndexChange: (swiper) => {
            this.dispatchEvent(
              new CustomEvent('swipper-slider:change', { bubbles: true, detail: { index: swiper.realIndex } })
            );
          },
        },
        ...this.swiperSettings["settings"]
      };

      this.currentSwiper = new Swiper(this.swiperContainer, options);
    }
  }

  customElements.define('swipper-slider', SwipperSlider);
}
